// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ef816695","453":"60e77de3"}[chunkId] + ".chunk.js";
};